export default __webpack_public_path__ + "static/media/plus.6c02e8ba.svg";